export default __webpack_public_path__ + "static/media/jpg_bg_2.323a3b00.png";